import { render, staticRenderFns } from "./SurgeryInsuranceInvoices.vue?vue&type=template&id=a4e695ec"
import script from "./SurgeryInsuranceInvoices.vue?vue&type=script&lang=js"
export * from "./SurgeryInsuranceInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports